/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-09-16 14:38:15
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-07 18:13:32
 * @FilePath: \ioc_base\src\modules\gatewayManager\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const routes = [{
    path: 'getwayControl',
    name: 'getwayControlIndex',
    component: () => import('./view/getwayControl'),
    meta: {
      // routerAlive: true
    },
  },
  {
    path: 'getwayConfig',
    name: 'getwayConfig',
    component: () => import('./view/getwayConfig'),
    meta: {
      routerAlive: true
    },
  },
  {
    path: 'getwayRecord',
    name: 'getwayRecord',
    component: () => import('./view/getwayRecord'),
    meta: {
      routerAlive: true
    },
  },
]

export default routes